<template>
  <div>
    <fieldset>
      <div class="row">
        <div class="col-md-6 d-flex align-items-center">
          <label class="form-check-label" for="showtracking">Enable Funding</label>
            <b-form-checkbox class="ml-2" switch :false-value="false" :true-value="true" role="switch"
              v-model="enabledFunding" 
            />
        </div>
        <div class="col-md-6 d-flex align-items-center">
            <label class="form-label">Client Email</label>
            <input class="form-control" type="email" v-model="email"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 d-flex align-items-center">
            <label class="form-label">Initial Balance ($)</label>
            <input class="form-control" type="text" v-model="initialBalance"/>
        </div>
        <div class="col-md-6 d-flex align-items-center">
            <label class="form-label">Notes</label>
            &nbsp;&nbsp;&nbsp;<textarea class="form-control" v-model="notes"></textarea>
        </div>
        <div class="col-md-3 d-flex align-items-center">
            <button type="button" :disabled="configureBalancBtnDisabled" @click="initialBalanceUpdate()" class="btn btn-primary float-right">Save (${{ new Intl.NumberFormat('en-US').format(this.initialBalance) }})
              <span v-if="configureBalancBtnDisabled"><i class="fa fa-spinner fa-spin"></i></span>
            </button>
        </div>
      </div>
    </fieldset>
    <fieldset>
        <div class="row">
            <div class="col-md-4 d-flex align-items-center">
                <label class="form-label">Current Balance ($)</label>
                <input class="form-control" disabled type="text" v-model="currentBalance" :class="[currentBalance >= 0 ? 'text-success' : 'text-danger']" />
            </div>
            <div class="col-md-2 align-items-center">
                <div class="form-check">
                    <input class="form-check-input" type="radio" v-model="operators" value="add" id="add" :disabled="!canUseNewFunding">
                    <label class="form-check-label" for="add">
                        Add
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" v-model="operators" value="subtract" id="subtract" :disabled="!canUseNewFunding">
                    <label class="form-check-label" for="subtract">
                        Subtract
                    </label>
                </div>
            </div>
            <div class="col-md-3 d-flex align-items-center">
                <label class="form-label">Amount($)</label>
                <input class="form-control" type="text" v-model="amount" :disabled="!canUseNewFunding" />
            </div>
        </div>
        <div class="row">
          <div class="col-md-9 d-flex align-items-center">
              <label class="form-label">Notes</label>
              &nbsp;&nbsp;&nbsp;<textarea class="form-control" v-model="balanceUpdateNotes" :disabled="!canUseNewFunding"></textarea>
          </div>
            <div class="col-md-3 d-flex align-items-center">
              <button type="button" :disabled="updateBalanceBtnDisabled" @click="updateBalance()" class="btn btn-primary">Update Balance (${{ new Intl.NumberFormat('en-US').format(this.amount) }})
                <span v-if="updateBalanceBtnDisabled"><i class="fa fa-spinner fa-spin"></i></span>
              </button>
            </div>
        </div>
    </fieldset>
  </div>
</template>
<script>
import FrontendService from '../../../../../services/FrontendService';
export default {
  name: "Funding",
  data() {
    return {
        canUseNewFunding: false,
        enabledFunding: false,
        email:"",
        initialBalance: 0,
        currentBalance: 0,
        operators:"",
        amount:"",
        notes:"",
        balanceUpdateNotes:"",

        configureBalancBtnDisabled: false,
        updateBalanceBtnDisabled: false,
    };
  },
  computed: {
    client() { 
      return this.$store.state.manageClients.client;
    },
  },
  methods: {
    initialBalanceUpdate() {
      this.configureBalancBtnDisabled = true;
      let data = {
        enableFundingFlow: this.enabledFunding,
        clientId:this.client.id.toString(),
        email: this.email,
        notes: this.notes,
        amount: parseFloat(this.initialBalance)
      }
      FrontendService.clientFundingConfiguration(data)
        .then((response) => {
          this.configureBalancBtnDisabled = false;
          if (response.status == 200) {
            this.canUseNewFunding = true;
            this.getClientBalance();
            alert("Funding flow enabled successfully.")
          } else {
            alert(response.data.message);
          }
        }).catch((e) => {
          this.configureBalancBtnDisabled = false;
          alert(e.response.data.message);
        });
    },
    getClientBalance() {
      let data = {
        clientId:this.client.id
      }
      FrontendService.getClientBalance(data)
        .then((response) => {
          if (response.status == 200) {
            if (response.data.balance_in_dollars <= 0) {
              this.currentBalance = Math.abs(response.data.balance_in_dollars)
            } else {
              this.currentBalance = Math.abs(response.data.balance_in_dollars) * -1
            }
            
          }
        }).catch((e) => {
          alert(e.response.data.message);
        });
    },
    updateBalance() {
      this.updateBalanceBtnDisabled = true;
      let data = {
        clientId: this.client.id.toString(),
        operator: this.operators,
        amount: parseFloat(this.amount),
        notes: this.balanceUpdateNotes,
      }
      FrontendService.updateBalance(data)
        .then((response) => {
          if (response.status == 200) {
            this.updateBalanceBtnDisabled = false;
            alert("Balance updated successfully.");
            this.getClientBalance();
          } else {
            this.updateBalanceBtnDisabled = false;
            alert(response.data.message);  
          }
        }).catch((e) => {
          this.updateBalanceBtnDisabled = false;
          alert(e.response.data.message);
        });
    }
  },
  beforeMount() {
      this.canUseNewFunding = this.client.canUseNewFunding;
      this.enabledFunding = this.client.canUseNewFunding;
      this.getClientBalance();
    //console.log(this.client);
  }
};
</script>
<style scoped>
.mb-4 {
  margin-bottom: 30px !important;
}
</style>
